import { useAtomValue } from 'jotai';
import { globalInteractions } from '@/common/atoms/global';
import { Scopes } from '$authentication/useHasPermission/constants';
import { useHasPermission } from '$authentication/useHasPermission/useHasPermission';

export function useGlobalAgentSearchEnabled() {
  const showGlobalInteractions = useAtomValue(globalInteractions);
  const { hasPermission } = useHasPermission({
    roles: ['ADMIN'],
    scopes: [Scopes.INTERACTIONS_WRITE],
  });

  return showGlobalInteractions && hasPermission;
}
